import React from "react";
import { Box, Typography, Button, Icon } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AppConfig from "../../config";

const AccessDenied = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
    >
      <Icon
        component={LockOutlinedIcon}
        sx={{ fontSize: 60, color: AppConfig.colorPalette.primary.main }}
      />
      <Typography variant="h5" sx={{ mt: 2 }}>
        Access Denied
      </Typography>
      <Typography color="textSecondary" sx={{ mt: 1, mb: 3 }}>
        You are not authorized to use this application.
      </Typography>
      <Button
        variant="contained"
        sx={{
          borderColor: AppConfig.colorPalette.primary.main,
          backgroundColor: AppConfig.colorPalette.primary.main,
          "&:hover": {
            backgroundColor: "#a00e50",
          },
          mt: 2,
        }}
        href="https://accountstg.eflag.in/"
      >
        Logout and Try Again
      </Button>
    </Box>
  );
};

export default AccessDenied;
